export default __webpack_public_path__ + "static/media/F_wdt_c_cap_1.f0876e36.mp3";